import React from 'react'
import "./ImageFront.css"
import { Col, Container, Row } from "react-bootstrap";
import Image from "react-bootstrap/Image";

const ImageFront = () => {
  return (

    <Container fluid className='py-3'>
      <Row>
        <Col className='fade-in-image'>
          <Image
            src='/profile-pic.png'
            roundedCircle
            fluid
            className="myself"
            alt='you should hire this guy'
          />
        </Col>
      </Row>
    </Container>
  )
}

export default ImageFront

